import { render, staticRenderFns } from "./OrderCreatorProduct.vue?vue&type=template&id=5b718159&scoped=true&"
import script from "./OrderCreatorProduct.vue?vue&type=script&lang=js&"
export * from "./OrderCreatorProduct.vue?vue&type=script&lang=js&"
import style0 from "./OrderCreatorProduct.vue?vue&type=style&index=0&id=5b718159&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b718159",
  null
  
)

export default component.exports